<p-toast [life]="3000"></p-toast>
<router-outlet></router-outlet>

<div
  *ngIf="currentUserService.authError()"
  style="
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
  "
>
  <div
    style="
      background: #fff;
      border-radius: 12px;
      padding: 2.5rem 3rem;
      max-width: 420px;
      width: 90%;
      text-align: center;
      box-shadow: 0 8px 32px rgba(0,0,0,0.2);
    "
  >
    <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #e53e3e; margin-bottom: 1rem; display: block;"></i>
    <h2 style="margin: 0 0 0.5rem; font-size: 1.25rem; color: #1a202c;">Session error</h2>
    <p style="color: #4a5568; margin: 0 0 1.5rem;">
      We could not load your account. You will be redirected to login in
      <strong>{{ currentUserService.authErrorCountdown() }}s</strong>.
    </p>
    <div style="height: 4px; background: #e2e8f0; border-radius: 9999px; overflow: hidden;">
      <div
        [ngStyle]="{ width: (currentUserService.authErrorCountdown() * 20) + '%', background: '#e53e3e', height: '100%', transition: 'width 1s linear' }"
      ></div>
    </div>
  </div>
</div>